import type { JSX as LocalJSX } from '@familyjs/core/components';
import React from 'react';

import type { RouterOptions } from '../../models';
import type { FamilyReactProps } from '../FamilyReactProps';
import { FmlTabButtonInner } from '../inner-proxies';

type Props = LocalJSX.FmlTabButton &
  FamilyReactProps & {
    routerOptions?: RouterOptions;
    ref?: React.Ref<HTMLFmlTabButtonElement>;
    onClick?: (e: CustomEvent) => void;
  };

export const FmlTabButton = /*@__PURE__*/ (() =>
  class extends React.Component<Props> {
    constructor(props: Props) {
      super(props);
      this.handleFmlTabButtonClick = this.handleFmlTabButtonClick.bind(this);
    }

    handleFmlTabButtonClick() {
      if (this.props.onClick) {
        this.props.onClick(
          new CustomEvent('fmlTabButtonClick', {
            detail: {
              tab: this.props.tab,
              href: this.props.href,
              routeOptions: this.props.routerOptions,
            },
          })
        );
      }
    }

    render() {
      /**
       * onClick is excluded from the props, since it has a custom
       * implementation within FmlTabBar.tsx. Calling onClick within this
       * component would result in duplicate handler calls.
       */
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { onClick, ...rest } = this.props;
      return <FmlTabButtonInner onFmlTabButtonClick={this.handleFmlTabButtonClick} {...rest}></FmlTabButtonInner>;
    }

    static get displayName() {
      return 'FmlTabButton';
    }
  })();
